import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { approveReturn } from "../../api/apiReturns";
import parseError from "../../utils/parseError";

export const useApproveReturn = () => {
    const queryClient = useQueryClient();

    const { mutate: approveReturnMutate, isPending: isApproving } = useMutation({
        mutationFn: ({ id, data }) => approveReturn(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Return approved successfully");
            queryClient.invalidateQueries(["returns"]);
            queryClient.invalidateQueries(["return"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to approve return");
        },
    });

    return { approveReturnMutate, isApproving };
};
